export const ORGANIZATIONS_COLUMNS = [
  { name: "organization", align: "left" },
  { name: "workspaces", align: "center" },
  { name: "admins", align: "center" },
  { name: "features", align: "center" },
  { name: "actions", align: "center" },
];

export const TEAMS_COLUMNS = [
  { name: "workspace", align: "left" },
  { name: "organization", align: "left" },
  { name: "actions", align: "center" },
];

// Everything an organization can have, laid out like the sidebar: a feature on
// its own, or a group (a tab) with the features inside it. The keys are the
// permission keys roles use (keep in sync with haazri-api/constants/permissions.js):
// a role can only do what its organization has.
export const FEATURE_TREE = [
  { key: "dashboard", label: "Dashboard" },
  {
    label: "Leave & WFH requests",
    children: [
      { key: "requests", label: "View requests" },
      { key: "requests.decide", label: "Approve or decline" },
    ],
  },
  {
    label: "Reports",
    children: [
      { key: "reports.general", label: "General report" },
      { key: "reports.leave_wfh", label: "Leave & WFH report" },
      { key: "reports.travel_allowance", label: "Travel allowance report" },
      { key: "reports.unapproved_absence", label: "Unapproved absence report" },
      { key: "reports.unresolved_comments", label: "Unresolved comments report" },
    ],
  },
  { key: "employees.manage", label: "Employees" },
  { key: "goals", label: "Goals" },
  { key: "assets.manage", label: "Assets" },
  { key: "users.manage", label: "Users & roles" },
  {
    label: "Settings",
    children: [{ key: "settings.public_holidays", label: "Public holidays" }],
  },
];

// Every feature key, flat.
export const FEATURES = FEATURE_TREE.flatMap((item) => item.children || [item]);

export const hasAllFeatures = (features) => !features || features.includes("*");

export const ORGANIZATIONS_MESSAGES = {
  nameRequired: "Name is required.",
  created: "Organization created successfully.",
  updated: "Organization updated successfully.",
  featuresUpdated: "Features updated successfully.",
  featuresRequired: "Select at least one feature.",
  moved: "Workspace moved successfully.",
  emptyTeams: "No workspaces found.",
};
